<template>
  <a v-if="visible && ad && adsEnabled" :href="ad.href" target="_blank" style="padding-bottom: 15px;">
    <img v-if="!ad.video" :alt="ad.alt" :src="ad.src" @load="startNextAdTimeout" />
    <video v-else autoplay muted @ended="nextAd">
      <source :src="ad.src" />
    </video>
  </a>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  props: {
    position: {
      type: String,
      required: true
    },
    visible: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  data() {
    return {
      ads: {
        header: [
          {
            src: require("@/assets/img/ads/header/AWARENESS_2023_BRAND_BUSINESSBLOOMS_SML_2000x180.gif"),
            href:
              "https://anzworldline.com.au/en/home/payment-moments.html?utm_source=online&utm_medium=SML&utm_campaign=brand23&utm_content=dcc-chips",
            alt: "ANZ Worldline - Business Blooms",
            duration: 10
          },
          {
            src: require("@/assets/img/ads/header/WRLD0090---SML_TAPONMOBILE_TRADERPORTAL_2000x180.gif"),
            href:
              "https://anzworldline.com.au/en/home/payment-solutions/eftpos-terminals/tap-on-mobile.html?utm_source=online&utm_medium=SML&utm_campaign=brand23&utm_content=TOM",
            alt: "ANZ Worldline - More Dough",
            duration: 15
          }
        ],
        footer: [
          {
            src: require("@/assets/img/ads/footer/AWARENESS_2023_BRAND_BUSINESSBLOOMS_SML_728x90.gif"),
            href:
              "https://anzworldline.com.au/en/home/payment-moments.html?utm_source=online&utm_medium=SML&utm_campaign=brand23&utm_content=dcc-chips",
            alt: "ANZ Worldline - Business Blooms",
            duration: 10
          },
          {
            src: require("@/assets/img/ads/footer/WRLD0090---SML_TAPONMOBILE_TRADERPORTAL_728x90.gif"),
            href:
              "https://anzworldline.com.au/en/home/payment-solutions/eftpos-terminals/tap-on-mobile.html?utm_source=online&utm_medium=SML&utm_campaign=brand23&utm_content=TOM",
            alt: "ANZ Worldline - More Dough",
            duration: 9
          }
        ]
      },
      currentAdIdx: 0
    };
  },
  computed: {
    ...mapGetters(["adsEnabled"]),
    adSet() {
      return this.ads[this.position];
    },
    ad() {
      return this.adSet[this.currentAdIdx];
    }
  },
  methods: {
    startNextAdTimeout() {
      setTimeout(this.nextAd, this.ad.duration * 1000);
    },
    nextAd() {
      this.currentAdIdx = (this.currentAdIdx + 1) % this.adSet.length;
    }
  }
};
</script>
